module.exports = __webpack_public_path__ + "img/salehIbrahem.a6a5ac92.jpg";